var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4774 0.590188C11.2007 0.771018 11.6405 1.50398 11.4597 2.2273L10.8665 4.59988H14.8334L15.5903 1.57246C15.7711 0.849134 16.5041 0.409357 17.2274 0.590188C17.9507 0.771018 18.3905 1.50398 18.2097 2.2273L17.6165 4.59988H20.95C21.6956 4.59988 22.3 5.2043 22.3 5.94988C22.3 6.69546 21.6956 7.29988 20.95 7.29988H16.9415L15.5915 12.6999H18.25C18.9956 12.6999 19.6 13.3043 19.6 14.0499C19.6 14.7955 18.9956 15.3999 18.25 15.3999H14.9165L14.1597 18.4273C13.9789 19.1506 13.2459 19.5904 12.5226 19.4096C11.7993 19.2287 11.3595 18.4958 11.5403 17.7725L12.1334 15.3999H8.16654L7.40969 18.4273C7.22886 19.1506 6.4959 19.5904 5.77257 19.4096C5.04925 19.2287 4.60947 18.4958 4.7903 17.7725L5.38345 15.3999H2.05C1.30441 15.3999 0.699997 14.7955 0.699997 14.0499C0.699997 13.3043 1.30441 12.6999 2.05 12.6999H6.05845L7.40845 7.29988H4.75C4.00441 7.29988 3.4 6.69546 3.4 5.94988C3.4 5.2043 4.00441 4.59988 4.75 4.59988H8.08345L8.8403 1.57246C9.02114 0.849134 9.7541 0.409357 10.4774 0.590188ZM10.1915 7.29988L8.84155 12.6999H12.8084L14.1584 7.29988H10.1915Z",
    fill: "#00B061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashTag);
export default __webpack_public_path__ + "static/media/HashTag.4c2a6859dfb290d55665781cd1df72ac.svg";
export { ForwardRef as ReactComponent };